import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import SupportList from './SupportList'
import SupportAdd from './SupportAdd'

function Support () {
  const { t } = useTranslation()
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const { logoutUser, updatePageName } = useContext(AuthContext)
  const [supportAdd, setSupportAdd] = useState(false)
  const [supportList, setSupportList] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [isDelete, setIsDelete] = useState(false)
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const getSupport = async payload => {
    try {
      if (payload?.deletePage) {
        payload = {
          page,
          pageSize
        }
        if (supportList?.length >= 1) {
          setPage(page - 1)
          setIsDelete(true)
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      } else {
        payload = {
          page,
          pageSize,
          sortBy: sort.sortBy,
          sortType: sort.sortType,
          type: 'company'
        }
        setIsDelete(false)
      }
      const path = apiPath.getSupport
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setSupportList(response?.docs)
        setPaginationObj({
          ...paginationObj,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null
        })
      }
    } catch (error) {
      console.log('error in get all support list==>>>>', error.message)
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    getSupport()
  }, [page, sort])

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleCategory = () => {
    setSupportAdd(!supportAdd)
  }

  useEffect(() => {
    updatePageName(t('SUPPORT'))
  }, [])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <div className=' border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 '>
              <div className='col-span-2 flex flex-wrap  items-center' />
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <div className='flex mt-2'>
                  <button
                    title={t('NEW_QUERY')}
                    className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    onClick={() => handleCategory()}
                  >
                    + {t('NEW_QUERY')}
                  </button>
                </div>
              </div>
            </div>
            <SupportList
              supportList={supportList}
              getSupport={getSupport}
              page={page}
              setSort={setSort}
              sort={sort}
            />
            {supportAdd ? (
              <SupportAdd
                getSupport={getSupport}
                supportAdd={supportAdd}
                handleCategory={handleCategory}
                setPage={setPage}
              />
            ) : null}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
